import path from 'path';

export const CURRENT_DRAFT_YEAR = 2026;

export const SIS_COMPANY_URL = 'https://sportsinfosolutions.com/';
export const WORDPRESS_URL = 'https://www.sportsinfosolutions.com';

export const ALLOWED_IFRAME_ORIGINS = [
  'https://sis-football-components-prod.s3.us-east-2.amazonaws.com',
  'https://sis-football-components-test.s3.us-east-2.amazonaws.com',
];

export const APP_URLS = {
  PROD: 'https://nfldraft.sportsinfosolutions.com',
  TEST: 'https://d1w1dxbinwj991.cloudfront.net',
  DEV: 'http://localhost:3333',
};

export const IFRAME_URLS = {
  PROD: 'https://sis-football-components-prod.s3.us-east-2.amazonaws.com',
  TEST: 'https://sis-football-components-test.s3.us-east-2.amazonaws.com',
};

export enum TDraftComponents {
  BIG_BOARD = 'draft-big-board',
  MATRIX = 'draft-matrix',
  PLAYER_STATS = 'draft-player-tabs',
  COMBINE_STATS = 'draft-query-tool',
  SCOUTS = 'our-scouts',
}

export const NAV_ROUTES = [
  {
    name: 'Big Board',
    path: '/big-board',
  },
  {
    name: 'Draft Matrix',
    path: '/matrix',
  },
  {
    name: 'Stats',
    path: '/stats',
  },
];

export const MOBILE_NAV_ROUTES = [
  ...NAV_ROUTES,
  {
    name: 'Scouts',
    path: '/scouts',
  },
  {
    name: 'Glossary',
    path: '/glossary',
  },
];

export const footballPositions = [
  'Quarterback',
  'Running Back',
  'Wide Receiver',
  'Tight End',
  'Tackle',
  'Guard',
  'Center',
  'Nose Tackle',
  'Defensive Tackle / 5-Tech',
  'Edge Rusher',
  'Mike Linebacker',
  'Will Linebacker',
  'Cornerback',
  'Safety',
];

export const SIS_URL = 'https://www.sportsinfosolutions.com/';

export const CONTACT_EMAIL = 'info@sportsinfosolutions.com';

export const TOS_URL = 'https://www.sis.utm.my/terms-of-service';

export const PRIVACY_URL = 'https://www.sis.utm.my/privacy-policy';

export const LEGACY_URL = 'http://archive.fieldingbible.com/';

export const SPONSOR_URL = 'https://www.insidetheleague.com/';

export const SIS_SOCIALS: ISocial[] = [
  {
    name: 'bluesky',
    url: 'https://bsky.app/profile/sportsinfosolutions.com',
    src: '/images/bluesky_logo.svg',
    alt: 'Bluesky Icon',
  },
  {
    name: 'x',
    url: 'https://www.x.com/football_sis',
    src: '/images/x_logo.svg',
    alt: 'X Icon',
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/company/sports-info-solutions',
    src: '/images/linkedin.svg',
    alt: 'LinkedIn Icon',
  },
];
